module.exports = __webpack_public_path__ + "media/images/slide-temp-e8f489feba7fb5b51d6451c735ca965d.jpg";